import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePatchOwnerManagerModifyParams, TypePatchOwnerManagerModifyResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 화주사 정보] 화주사 담당자 수정
 */
const usePatchOwnerManagerModify = () => {
  const endPoint = '/api-owner/owner-manager/modify';

  const patchOwnerManagerModify = async (params: TypePatchOwnerManagerModifyParams) => {
    return axiosInstance
      .patch<TypePatchOwnerManagerModifyResponse>(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { patchOwnerManagerModify };
};

export default usePatchOwnerManagerModify;
